import { Table } from "antd";
import React, { useEffect } from "react";
import { Planscolumns2 } from "./PlansColumn2";

const AllPlans2 = (props) => {
  const { group_name, data, setAmount } = props;
  // console.log(props, "props");
  useEffect(() => {}, [group_name, data]);
  return (
    <>
      <Table
        className="custom-table h-[320px] overflow-x-auto text-white rounded-none"
        columns={Planscolumns2(setAmount)}
        pagination={false}
        dataSource={data}
      />
    </>
  );
};

export default AllPlans2;
